import React from "react";
import { Row, Col, Card, Button, Badge } from "react-bootstrap";
import { Icon } from "@iconify/react";
import IMAGES from "../constants/images";

const PricingCards = ({ websiteUrl, plans = [] }) => {
  const planImages = [
    IMAGES.Circle_IMG1,
    IMAGES.Circle_IMG2,
    IMAGES.Circle_IMG3,
  ];

  return (
    <div className="overflow-auto">
      <Row className="pricing_Box flex-nowrap" >
  {plans?.map((plan, index) => {
    const features =
      plan?.features?.length > 0
        ? plan.features.map(v => v?.value ?? v)
        : plan?.feature?.map(v => v?.value ?? v);

    const highlight = plans.length > 2 ? index === 1 : index === 0;

    return (
      <Col key={index} xs={12} md={6} lg={4} className="pricing_card" style={{ marginTop: "10px",}}>
        <Card
          className={`h-100 d-flex flex-column ${
            highlight ? "bg-primary text-white" : "bg-white"
          }`}
        >
          <Card.Body className="d-flex flex-column">
            <div className="pricing_header mb-2">
              <div
                className="circle_img"
                style={{
                  backgroundColor: highlight ? "#ffffff" : "#CFE3F8",
                }}
              >
                <Card.Img
                  variant="top"
                  src={planImages[index % planImages.length]}
                  style={{
                    width: "35px",
                    height: "35px",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div className="flex-grow-1">
                <h6
                  className={`mb-1 ${
                    highlight ? "text-white" : "text-muted"
                  }`}
                >
                  For {plan?.seats || ""} Seats  
                </h6>
                <h4 className="fw-bold mb-0">{plan.name}</h4>
              </div>
              {/* {highlight && <Badge text="primary">Popular</Badge>} */}
            </div>

            <p
              className={`pricingPara ${
                highlight ? "text-white" : "text-muted"
              }`}
              style={{ textAlign: "justify" }}
            >
              {plan?.description}
            </p>

            <h2 className={`fw-bold ${highlight ? "text-white" : "text-dark"}`}>
              ${plan?.price}
              <span
                className={`fs-5 ${highlight ? "text-white" : "#6E6E73"}`}
              >
                /monthly
              </span>
            </h2>

            <h6 className="fw-bold mt-3">What's included</h6>
            <ul className="list-unstyled text-start flex-grow-1">
              {features?.map((feature, idx) => (
                <li key={idx} className="d-flex align-items-center">
                  <Icon
                    icon="icon-park-solid:check-one"
                    fontSize={24}
                    style={{ minHeight: "30px", minWidth: "30px" }}
                    color={highlight ? "#ffffff" : "#0071E3"}
                  />
                  <span className="ms-2">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="mt-auto">
              <Button
                variant={highlight ? "light" : "info"}
                className="w-100 rounded-pill"
                onClick={() => {
                  window.open(websiteUrl, "_blank");
                }}
              >
                Try For Free
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Col>
    );
  })}
</Row>
</div>
  );
};

export default PricingCards;
